import control from './controls/control';
import constants from './constants';

const getExtension = () => ({
  slug: constants.common.slug,
  title: 'WS Slider Customizer',
  description: 'Extension for editing slider',
  settings: {
    querySelector:
      '[id*="ws-block-slider-gallery"] ws-media-container[origin-src], [src*=\'/cover-splitscreen-with-slider/\'] ws-media-container[origin-src]',
    sliderGalleryQuerySelector: 'ws-slider',
  },
  ui: {
    control: [control],
  },
});

export default getExtension;
